import { z } from 'zod/mini'

import { checkoutRedirectToOptions } from './search-schema'

export const checkoutCompleteSearchSchema = z.object({
  redirectTo: z.optional(z.enum(checkoutRedirectToOptions)),
  session_id: z.string(),
})
